import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import AdminDashboardPage from './pages/AdminDashboardPage';
import CreateExpenseEventPage from './pages/CreateExpenseEventPage';
import AdminAnalyticsPage from './pages/admin/AdminAnalyticsPage';
import AdminControlTowerPage from './pages/admin/AdminControlTowerPage';
import AdminExpensesPage from './pages/admin/AdminExpensesPage';
import AdminReimbursementsPage from './pages/admin/AdminReimbursementsPage';
import AdminSettingsPage from './pages/admin/AdminSettingsPage';
import AdminTeamApprovalsPage from './pages/admin/AdminTeamApprovalsPage';
import AdminTripsPage from './pages/admin/AdminTripsPage';
import EmployeeDashboardPage from './pages/EmployeeDashboardPage';
import ExpenseEventDetailPage from './pages/ExpenseEventDetailPage';
import LoginPage from './pages/LoginPage';
import ManagerDashboardPage from './pages/ManagerDashboardPage';
import OAuthCallbackPage from './pages/OAuthCallbackPage';
import PublicLeadFormPage from './pages/PublicLeadFormPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import InvoiceUploadPage from './pages/InvoiceUploadPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SignupPage from './pages/SignupPage';
import TripsWorkspacePage from './pages/TripsWorkspacePage';

const App: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/contact" element={<PublicLeadFormPage />} />
      <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
      <Route path="/admin/control-tower" element={<AdminControlTowerPage />} />
      <Route path="/admin/expenses" element={<AdminExpensesPage />} />
      <Route path="/admin/trips" element={<AdminTripsPage />} />
      <Route path="/admin/team-approvals" element={<AdminTeamApprovalsPage />} />
      <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
      <Route path="/admin/reimbursements" element={<AdminReimbursementsPage />} />
      <Route path="/admin/settings" element={<AdminSettingsPage />} />
      <Route path="/admin/expense-events/:eventId" element={<ExpenseEventDetailPage />} />
      <Route path="/manager/dashboard" element={<ManagerDashboardPage />} />
      <Route path="/manager/expense-events/:eventId" element={<ExpenseEventDetailPage />} />
      <Route path="/manager/history" element={<EmployeeDashboardPage />} />
      <Route path="/manager/trips" element={<TripsWorkspacePage />} />
      <Route path="/manager/expenses/new" element={<CreateExpenseEventPage />} />
      <Route path="/manager/invoices" element={<InvoiceUploadPage />} />
      <Route path="/employee/dashboard" element={<EmployeeDashboardPage />} />
      <Route path="/employee/trips" element={<TripsWorkspacePage />} />
      <Route path="/employee/expense-events/:eventId" element={<ExpenseEventDetailPage />} />
      <Route path="/employee/expenses/new" element={<CreateExpenseEventPage />} />
      <Route path="/employee/invoices" element={<InvoiceUploadPage />} />
      <Route path="/oauth/callback" element={<OAuthCallbackPage />} />
      <Route path="*" element={<Layout />} />
    </Routes>
  );
};

export default App;
